import { ReactNode } from "react";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IconHidden } from "src/components/icons-mui/hidden";
import { Typography } from "src/components-mui/base/typography/typography";

interface IErrorStateProps {
    children?: ReactNode;
}

export const ErrorState = ({ children }: IErrorStateProps) => {
    const { t } = useTranslation("common");

    return (
        <Box sx={{ position: "relative" }}>
            {children}
            <Stack sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
                <Stack sx={{ position: "relative", alignItems: "center", px: 8, pt: 8, pb: 3, bgcolor: "white", boxShadow: 1, borderRadius: "8px" }}>
                    <IconHidden sx={{ position: "absolute", top: "-70px", fontSize: 136 }} />
                    <Typography component="p" sx={{ fontSize: "lg", fontWeight: "semibold", textAlign: "center", bgcolor: "white", p: 1, mt: 0.5 }}>
                        {t("no-data")}
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};
